export class DocumentStatus {
  public id: number;
  public description?: string;
  public ordreAffichage?: number;
  public defaultEntrant: boolean; // Indicates wether it is the default status of mail Entrant
  public defaultSortant: boolean; // Indicates wether it is the default status of mail Sortant
  public notUsed: boolean;
  public color?: string;
  public globalStatutId?: number;
  public specificStatusId?: number;
  public globalStatutName?: string;
  public specificStatutName?: string;

  constructor(data: Partial<DocumentStatus>) {
    Object.assign(this, data);
  }
}
